import { render } from "./Page.vue?vue&type=template&id=5703da08"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=5703da08&lang=css"
script.render = render

export default script